import * as Yup from 'yup';
import { FormFields } from './types';

const IDENTIFIER_REQUIRED_MESSAGE = 'Provide an MRN, or a transport document type and reference number.';

/**
 * Only applies to the consult opened from the ENS listing, where no declaration is in scope: customs
 * needs enough to match the request to a single ENS, which means the requester's EORI plus either the
 * MRN or a transport document — and a transport document is only usable as a pair (type + reference).
 * Opened from a declaration, the ENS is already identified and none of this is asked for.
 */
export const identificationValidationSchema = Yup.object({
    [FormFields.REQUESTER_EORI]: Yup.string()
        .max(17, 'Requester EORI cannot be longer than 17 characters.')
        .required('Requester EORI is required.')
        .nullable(),
    [FormFields.MRN]: Yup.string()
        .max(18, 'MRN cannot be longer than 18 characters.')
        .nullable()
        .test('identifier-provided', IDENTIFIER_REQUIRED_MESSAGE, function (value) {
            const { transportDocumentType, transportDocumentReferenceNumber } = this.parent;
            return Boolean(value) || Boolean(transportDocumentType && transportDocumentReferenceNumber);
        }),
    [FormFields.TRANSPORT_DOCUMENT_TYPE]: Yup.string()
        .nullable()
        .test('type-provided-with-reference', 'Transport document type is required.', function (value) {
            return Boolean(value) || !this.parent.transportDocumentReferenceNumber;
        }),
    [FormFields.TRANSPORT_DOCUMENT_REFERENCE_NUMBER]: Yup.string()
        .max(70, 'Transport document reference number cannot be longer than 70 characters.')
        .nullable()
        .test('reference-provided-with-type', 'Transport document reference number is required.', function (value) {
            return Boolean(value) || !this.parent.transportDocumentType;
        }),
});
